import React, { FC } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { ReduxState } from 'app/redux/types';

import { useTranslation } from 'app/lang';
import { selectBets } from 'app/modules/BetSlip/selectors/entries';

import dictionary from './BetSlipLabel.dictionary.json';

import styles from './BetSlipLabel.module.scss';

// ---

type StoreProps = {
  entriesSize: number;
};

const BetSlipLabel: FC<StoreProps> = ({ entriesSize }) => {
  const { t } = useTranslation();

  const hasEntries = entriesSize > 0;

  const _labelClassName = classNames(styles.label, {
    [styles.labelWithEntries]: hasEntries,
  });

  const _entriesClassName = classNames(styles.entries, {
    [styles.visibleEntries]: hasEntries,
  });

  return (
    <div className={styles.container}>
      <span className={_labelClassName}>
        {t(dictionary.label)}
      </span>
      <span className={_entriesClassName}>
        {entriesSize}
      </span>
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  entriesSize: selectBets(state).size,
});

export default connect(mapStateToProps)(BetSlipLabel);
